/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExamQuestionTaskRef } from './examQuestionTaskRef';
import type { AnswerKeyPoint } from './answerKeyPoint';

/**
 * A generated oral exam question.

task_ref is the join key back to module tasks (T01..T0N from export).
task is a human-readable label for display; not used for linkage.
 */
export interface ExamQuestion {
  task: string;
  taskRef?: ExamQuestionTaskRef;
  concept: string;
  bloom: string;
  question: string;
  answerKey: AnswerKeyPoint[];
  estTimeSec: number;
}
